import React from 'react';
import {
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
  Slide,
  DialogProps,
  IconButton,
  Box,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ResponsiveDialogProps extends Omit<DialogProps, 'children'> {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
}

export default function ResponsiveDialog({
  open,
  onClose,
  children,
  maxWidth = 'sm',
  ...other
}: ResponsiveDialogProps) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      fullScreen={fullScreen}
      TransitionComponent={fullScreen ? Transition : undefined}
      PaperProps={{
        sx: fullScreen
          ? {
            position: 'absolute',
            bottom: 0,
            m: 0,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            height: 'unset',
            maxHeight: '95%',
          }
          : {},
      }}
      {...other}
    >
      {/* Sticky close button with gradient */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          px: 1.5,
          pt: 1,
          pb: 0.5,
          background: theme => `linear-gradient(to bottom, ${theme.palette.background.paper} 60%, transparent 100%)`,
        }}
      >
        <Stack direction="row" justifyContent="flex-end">
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </Box>

      <DialogContent sx={{ overflowY: 'auto', paddingTop: '0px' }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
